import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import TrialArticle from "./routes/TrialArticle";
import Article from "./components/Article";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./routes/Home";
import { useState } from "react";
import Login from "./routes/Login"; // Import the Login component
import BirthdayComponent from "./components/Birthday";
import HalfBirthday from "./components/HalfBirthday";
import BirthdayClue from "./components/BirthdayClue";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
  };
  return (
    <div
      className="App"
      style={{ display: "flex", flexDirection: "column", height: "100vh" }}
    >
      <Router style={{ flex: 1 }}>
        <ScrollToTop />
        <Header isAuthenticated={isAuthenticated} />
        <div className="content" style={{ flex: 1 }}>
          <Routes>
            {/* Public Route: Login */}
            <Route
              path="/login"
              element={<Login onLoginSuccess={handleLoginSuccess} />}
            />

            {/* Protected Route: Home (accessible only if authenticated) */}
            <Route
              path="/"
              element={isAuthenticated ? <Home /> : <Navigate to="/login" />}
            />

            {/* Other routes */}
            <Route
              path="/waitress"
              element={isAuthenticated ? <Article /> : <Navigate to="/login" />}
            />
            <Route
              path="/road"
              element={isAuthenticated ? <Article /> : <Navigate to="/login" />}
            />
            <Route
              path="/ski"
              element={isAuthenticated ? <Article /> : <Navigate to="/login" />}
            />
            <Route
              path="/trial"
              element={isAuthenticated ? <Article /> : <Navigate to="/login" />}
            />
            <Route
              path="/hike"
              element={isAuthenticated ? <Article /> : <Navigate to="/login" />}
            />
            <Route
              path="/gondola"
              element={isAuthenticated ? <Article /> : <Navigate to="/login" />}
            />
            <Route
              path="/nun"
              element={isAuthenticated ? <Article /> : <Navigate to="/login" />}
            />
            <Route
              path="/cathedral"
              element={isAuthenticated ? <Article /> : <Navigate to="/login" />}
            />
            <Route
              path="/skye"
              element={isAuthenticated ? <Article /> : <Navigate to="/login" />}
            />
            <Route
              path="/biking"
              element={isAuthenticated ? <Article /> : <Navigate to="/login" />}
            />
            <Route
              path="/vehicle"
              element={isAuthenticated ? <Article /> : <Navigate to="/login" />}
            />
            <Route
              path="/hiking"
              element={isAuthenticated ? <Article /> : <Navigate to="/login" />}
            />
            <Route
              path="/pizza"
              element={isAuthenticated ? <Article /> : <Navigate to="/login" />}
            />
            <Route
              path="/community-service"
              element={isAuthenticated ? <Article /> : <Navigate to="/login" />}
            />
            <Route path="/birthday-clue" element={<BirthdayClue />} />
            <Route path="/next-clue" element={<BirthdayClue />} />
            {/* <Route path="/half-birthday" element={<HalfBirthday />} />
            <Route path="/college" element={<HalfBirthday />} />
            <Route path="/chocolate" element={<HalfBirthday />} />
            <Route path="/trioak" element={<HalfBirthday />} />
            <Route path="/marg" element={<HalfBirthday />} />
            <Route path="/state" element={<HalfBirthday />} />
            <Route path="/sensitivity" element={<HalfBirthday />} />
            <Route path="/distress" element={<HalfBirthday />} />
            <Route path="/randall" element={<HalfBirthday />} />
            <Route path="/picky" element={<HalfBirthday />} />
            <Route path="/kitties" element={<HalfBirthday />} />
            <Route path="/proceed" element={<HalfBirthday />} />
            <Route path="/final" element={<HalfBirthday />} />
            <Route
              path="/birthday"
              element={
                isAuthenticated ? (
                  <BirthdayComponent />
                ) : (
                  <Navigate to="/login" />
                )
              }
            /> */}
          </Routes>
        </div>
      </Router>
      <Footer />
    </div>
  );
}

export default App;
